<div class="modal-dialog modal-dialog_captcha">
  <div class="modal__header">
    <div class="modal__title" i18n="@@captcha.gun_question">Что это за оружие?</div>
  </div>

  <div class="captcha">
    <div class="captcha__picture">
      <img
        loading="lazy"
        class="captcha__image"
        [src]="data.captcha.image"
        alt=""
        fetchpriority="low"
      />
    </div>

    @if (countdown$ | async; as countdown) {
      <div class="captcha__time-text" i18n="@@captcha.countdown">Осталось <span class="text_bold">{{ countdown.secondsLeft }}</span> секунд</div>

      <div class="captcha__progress progress progress_md progress_theme_rainbow">
        <div class="progress__bar"
          [style.width.%]="countdown.progress"
        ></div>
      </div>
    }

    <div class="captcha__variants">
      @for (variant of data.captcha.variants; track variant) {
        <button class="btn btn_grey" type="button"
          (click)="selectVariant(variant)"
          [disabled]="isAnswering()"
          [class.is-loading]="isAnswering() === variant"
        >
          {{ variant }}
        </button>
      }
    </div>

    <span class="captcha__help" i18n="@@captcha.bot_disclaimer">Мы хотим убедится, что Вы не бот</span>
  </div>
</div>
